import React from "react";
import imgC from "../../assets/image/services/ocorie-srv-splash-img-training.png";

const Hero = () => {
  return (
    <div className="pt-20 pt-md-23 pt-lg-24">
      <div className="container">
        {/* Section Padding */}
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-11">
            <div
              className="text-center mb-11 mb-lg-16"
              data-aos="fade-up"
              data-aos-duration={300}
              data-aos-delay={100}
            >
              <h2 className="font-size-11 mb-5">Cybersecurity Training</h2>
              <p className="font-size-7 mb-0">
                We build capacity for internal Cybersecurity Staff to world-class talent by offering tailored information security courses.
              </p>
            </div>
          </div>
        </div>
        {/* End Section Padding */}
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div
              className="rounded-8"
              data-aos="fade-up"
              data-aos-duration={300}
              data-aos-delay={200}
            >
              <img className="w-100" src={imgC} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
